import lodash from "lodash";
import axiosOverlay from '../../js/axiosOverlay'

const state = {
    suivis: null,
    selectedSuivi: null
};

const getters = {
    suivis: state => state.suivis,
    selectedSuivi: state => state.selectedSuivi,
    getSuivisOrderByDate: (state) => {
        if (state.suivis !== null) {
            let result = lodash.orderBy(JSON.parse(state.suivis), ['datesuivi'], ['desc'])
            return result
        }
        return []
    },
    getSuiviByID: (state) => (SuiviID) => {
        if (state.suivis !== null) {
            return JSON.parse(state.suivis).find(suivi => suivi.id === SuiviID) ?? null
        }
        return null
    }
};

const mutations = {
    SET_SUIVIS(state, suivis) {
        state.suivis = suivis;
    },
    SET_SELECTED_SUIVI(state, suivi) {
        state.selectedSuivi = suivi;
    },
    CLEAR_SUIVIS(state) {
        state.suivis = null;
    }
};

const actions = {
    async loadSuivisFromAPI({ commit, rootGetters }, sollicitationID) {
        let mesEvents = rootGetters['evenements/iCantRead'];
        let idEvents = JSON.stringify(mesEvents.map(function(value) { return value['id']; }));

        let mesActions = rootGetters['actions/iCantRead'].filter(e => !idEvents.includes(e.evenement));
        let idActions = JSON.stringify(mesActions.map(function(value) { return value['id']; }));

        let baseUrl = process.env.VUE_APP_API_URL + "/suivisollicitations?sollicitation=" + sollicitationID;
        if (mesEvents.length > 0)
            baseUrl += "&evenement=" + idEvents
        if (mesActions.length > 0)
            baseUrl += "&action=" + idActions;

        let config = {
            method: 'get',
            url: baseUrl,
            headers: {}
        };

        try {
            const response = await axiosOverlay(config);
            let result = JSON.stringify(response.data);
            commit('SET_SUIVIS', result);
        } catch (error) {
            console.log(error);
        }
    },
    
    async createSuivi(context, suivi) {
        suivi = JSON.parse(suivi)

        let arrayData = {
            "sollicitation": suivi.sollicitation,
            "evenement": suivi.evenement,
            "action": suivi.action,
        };
        
        if (!suivi.auteur){
            arrayData['description'] = "[" + suivi.username + "] " + suivi.details
        }
        else{
            arrayData['auteur'] = parseInt(suivi.auteur);
            arrayData['description'] = suivi.details
        } 

        let data = JSON.stringify(arrayData);

        let config = {
            method: 'post',
            url: process.env.VUE_APP_API_URL + "/suivisollicitations",
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        try {
            const response = await axiosOverlay(config);
            if (response.status === 200 || response.status === 201) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log('error', error);
            return false;
        }
    },
    
    clearSuivis({ commit }) {
        commit('CLEAR_SUIVIS');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
